import React, { memo } from 'react'
import styles from './CommonPagination.module.scss'
import { BounceLoader } from 'react-spinners'

type Props = {
    numberOfPages: number
    currentPage: number
    isLoading?: boolean
    onPageChange: (page: number) => void
}

const CommonPagination: React.FC<Props> = memo((props: Props) => {
    const { numberOfPages, currentPage, isLoading, onPageChange } = props

    const goToFirstPage = () => {
        onPageChange(1)
    }

    const goToPreviousPage = () => {
        if (currentPage === 1) return
        onPageChange(currentPage - 1)
    }

    const goToNextPage = () => {
        if (currentPage === numberOfPages) return
        onPageChange(currentPage + 1)
    }

    const goToLastPage = () => {
        onPageChange(numberOfPages)
    }

    const changePage = (page: number) => {
        onPageChange(page)
    }

    const pageButtonsBuilder = () => {
        const buttons = []

        for (let i = currentPage - 2; i <= currentPage + 2; i++) {
            if (i > 0 && i <= numberOfPages) {
                buttons.push(
                    <button key={i} className={`standardButton ${styles.button} ${currentPage === i ? styles.selected : ''}`} onClick={() => changePage(i)}>
                        {i}
                    </button>
                )
            }
        }

        return buttons
    }


    return (
        <div className={styles.container}>
            <div className={styles.infoContainer}>
                {
                    numberOfPages > 0 ? `Page ${currentPage} of ${numberOfPages}` : 'No data present'
                }
                {
                    isLoading ? <BounceLoader size={30} color="#30AA53"/> : <></>
                }
            </div>
            {
                !!numberOfPages && <div className={styles.paginationContainer}>
                    <button className={`standardButton ${styles.button}`} onClick={goToFirstPage}>
                        <svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19.0377 10.6005L17.9839 11.6543L12.3301 6.00047L17.9839 0.346646L19.0377 1.40047L14.4531 6.00047L19.0377 10.6005ZM13.0377 10.6005L11.9839 11.6543L6.33008 6.00047L11.9839 0.346646L13.0377 1.40047L8.4531 6.00047L13.0377 10.6005ZM7.0377 10.6005L5.9839 11.6543L0.330078 6.00047L5.9839 0.346646L7.0377 1.40047L2.4531 6.00047L7.0377 10.6005Z" fill="#1C1B1F" />
                        </svg>
                    </button>
                    <button className={`standardButton ${styles.button}`} onClick={goToPreviousPage}>
                        <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.0534 10.6005L11.9995 11.6543L6.3457 6.00047L11.9995 0.346646L13.0534 1.40047L8.46873 6.00047L13.0534 10.6005ZM7.05335 10.6005L5.99953 11.6543L0.345703 6.00047L5.99953 0.346646L7.05335 1.40047L2.46873 6.00047L7.05335 10.6005Z" fill="#1C1B1F" />
                        </svg>
                    </button>
                    {
                        pageButtonsBuilder()
                    }
                    <button className={`standardButton ${styles.button}`} onClick={goToNextPage}>
                        <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.946646 1.39953L2.00047 0.345703L7.6543 5.99953L2.00047 11.6534L0.946646 10.5995L5.53127 5.99953L0.946646 1.39953ZM6.94665 1.39953L8.00047 0.345703L13.6543 5.99953L8.00047 11.6534L6.94665 10.5995L11.5313 5.99953L6.94665 1.39953Z" fill="#1C1B1F" />
                        </svg>
                    </button>
                    <button className={`standardButton ${styles.button}`} onClick={goToLastPage}>
                        <svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.962297 1.39953L2.0161 0.345703L7.66992 5.99953L2.0161 11.6534L0.962297 10.5995L5.5469 5.99953L0.962297 1.39953ZM6.9623 1.39953L8.0161 0.345703L13.6699 5.99953L8.0161 11.6534L6.9623 10.5995L11.5469 5.99953L6.9623 1.39953ZM12.9623 1.39953L14.0161 0.345703L19.6699 5.99953L14.0161 11.6534L12.9623 10.5995L17.5469 5.99953L12.9623 1.39953Z" fill="#1C1B1F" />
                        </svg>
                    </button>
                </div>
            }
        </div>
    )
})

export default CommonPagination